import { useMemo } from 'react';
import { AssetKeys } from '@components/EntityDrawers/drawers/Assessment/keys';
import ControlledTextFieldSelect from '@components/Inputs/controllers/ControlledTextFieldSelect';
import { ISelectOption } from '@constants/entities/ui';
import { useProject } from '@context/Project/ProjectProvider';
import useProjectSettings from '@hooks/useProjectSettings';
import { settingsRowToString } from '@views/ProjectSettings/components/ProjectDetailsSettings/helpers/helpers';

const AssetCriticalityLevelDropdown = () => {
  const { viewOnly } = useProject();

  const {
    settings: { asset_criticality_level },
  } = useProjectSettings();

  const options: ISelectOption[] = useMemo(
    () =>
      (asset_criticality_level ?? []).map((row) => {
        const v = settingsRowToString(row);
        return { label: v, value: v };
      }),
    [asset_criticality_level],
  );

  return (
    <ControlledTextFieldSelect
      name={AssetKeys.Criticality}
      label="Asset criticality rating"
      placeholder="Asset criticality rating"
      disabled={viewOnly}
      options={options}
      resetOnDoubleClick
      required
    />
  );
};

export default AssetCriticalityLevelDropdown;
